"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var VideoCameraControlFillNo = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_VideoCameraControlFillNo_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 16,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 11.5A1.5 1.5 0 0 1 9.5 13H3a3 3 0 0 1-3-3V4.5A1.5 1.5 0 0 1 1.5 3H8a3 3 0 0 1 3 3v5.5ZM6.5 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-.646-3.354a.5.5 0 0 0-.708 0l-.9.9a.5.5 0 1 0 .708.708l.546-.547.546.547a.5.5 0 1 0 .708-.708l-.9-.9Zm-2.1 2.808a.5.5 0 1 0-.708-.708l-.9.9a.5.5 0 0 0 0 .708l.9.9a.5.5 0 1 0 .708-.708L3.207 8l.547-.546Zm4.2-.708a.5.5 0 1 0-.708.708L7.793 8l-.547.546a.5.5 0 1 0 .708.708l.9-.9a.5.5 0 0 0 0-.708l-.9-.9Zm-1.2 3.708a.5.5 0 0 0-.708-.708l-.546.547-.546-.547a.5.5 0 1 0-.708.708l.9.9a.5.5 0 0 0 .708 0l.9-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.8 3.9-2.2 1.65a1.5 1.5 0 0 0-.6 1.2v2.5c0 .472.222.917.6 1.2l2.2 1.65a.75.75 0 0 0 1.2-.6v-7a.75.75 0 0 0-1.2-.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_VideoCameraControlFillNo_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = VideoCameraControlFillNo;
exports["default"] = _default;